"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WAREHOUSES = void 0;

var _createWarehouse = require("./createWarehouse");

var _deleteWarehouse = require("./deleteWarehouse");

var _editWarehouse = require("./editWarehouse");

var _general = require("./general");

var WAREHOUSES = {
  CREATE_WAREHOUSE: _createWarehouse.CREATE_WAREHOUSE,
  DELETE_WAREHOUSE: _deleteWarehouse.DELETE_WAREHOUSE,
  EDIT_WAREHOUSE: _editWarehouse.EDIT_WAREHOUSE,
  GENERAL: _general.GENERAL
};
exports.WAREHOUSES = WAREHOUSES;